import { HttpContextToken } from '@angular/common/http';

/** Only configured screen APIs opt into overriding system header defaults. */
export const SCREEN_API_HEADER_OVERRIDES = new HttpContextToken<boolean>(() => false);
